<div [ngStyle]="
{ 'width': version === 'vertical' ? '100px' : '200px',
  'height': version === 'vertical' ? '100px' : '50px',
  'max-width': version === 'vertical' ? '150px' : '250px',
  'max-height': version === 'vertical' ? '100px' : '50px',
  'background-color': parentDivBgColor
}">
  <img [src]="logoSrc"
       [ngStyle]="{
       'width': '100%',
       'height': '100%',
       'cursor': 'pointer'
       }"
       [title]="'NETOPIA Payments'"
       (click)="goToNetopiaPaymentsWebsite()"
       alt='Netopia Payments Logo'>
</div>


